export default __webpack_public_path__ + "static/media/main-video.fc279001.mp4";